import { loginRequest } from "../authConfig";
import * as microsoftTeams from "@microsoft/teams-js";



export async function getValidAccessToken(instance, accounts) {
  try {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (e) {
    // Do not call acquireTokenPopup automatically; let the caller handle it
    throw e;
  }
}

// export async function fetchUserDetailsByWebEmail(instance, accounts, email) {
//   const accessToken = await getValidAccessToken(instance, accounts);

//   const response = await fetch(`https://graph.microsoft.com/v1.0/users/${email}`, {
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error("User not found or insufficient permissions");
//   }

//   const user = await response.json();

//   return {
//     firstName: user.givenName,
//     lastName: user.surname,
//   };
// }
// export async function fetchUserDetailsByEmail(instance, accounts, email) {
//   try {
//     const normalizedEmail = email.trim();

//     // Detect if running in Teams and get the correct token
//     let tagValue = "graph";
//     let accessToken;
//     try {
//       const context = await microsoftTeams.app.getContext();
//       tagValue = "teams";
//       // Get Teams SSO token
//       accessToken = await new Promise((resolve, reject) => {
//         microsoftTeams.authentication.getAuthToken({
//           successCallback: resolve,
//           failureCallback: reject,
//           resources: ['https://graph.microsoft.com']
//         });
//       });
//     } catch (e) {
//       tagValue = "graph";
//       // Get MSAL access token for web
//       accessToken = await getValidAccessToken(instance, accounts);
//     }

//     // email and tag go into the query string
//     const url = `https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/user-details?email=${encodeURIComponent(normalizedEmail)}&tag=${encodeURIComponent(tagValue)}`;
//     console.log("🌐 Request URL:", url);

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${accessToken}`,
//       },
//     });

//     console.log("📥 Status:", response.status);

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error("❌ API Error:", response.status, errorText);
//       throw new Error("API returned error");
//     }

//     const user = await response.json();
//     console.log("📦 User from API:", user);

//     return {
//       firstName: user.firstName || user.first_name,
//       lastName: user.lastName || user.last_name,
//       email: user.email,
//     };
//   } catch (error) {
//     console.error("❌ fetchUserDetailsByEmail failed:", error);
//     throw error;
//   }
// }
export async function fetchUserDetailsByEmail(instance, accounts, email) {
  console.log("🚀 fetchUserDetailsByEmail START");
  console.log("📨 Email:", email);

  let accessToken;
  let tagValue = "graph";

  try {
    console.log("🧭 Checking if in Teams...");
    let isInTeams = false;

    try {
      await microsoftTeams.app.initialize();
      await microsoftTeams.app.getContext();
      isInTeams = true;
    } catch (e) {
      console.log("❌ Not in Teams or Teams init failed:", e);
    }

    console.log("🧭 Is in Teams:", isInTeams);

    if (isInTeams) {
      tagValue = "teams";
      console.log("🔐 Trying to get token from Teams...");
      accessToken = await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: (token) => {
            console.log("✅ Got token from Teams");
            resolve(token);
          },
          failureCallback: (err) => {
            console.error("❌ Failed to get Teams token:", err);
            reject(err);
          },
          resources: ["https://graph.microsoft.com"],
        });
      });
    } else {
      console.log("🔐 Getting web token via MSAL...");
      accessToken = await getValidAccessToken(instance, accounts);
      console.log("✅ Got web access token");
    }

    console.log("📦 Access Token:", accessToken?.substring(0, 20) + "...");

    const url = `https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/user-details?email=${encodeURIComponent(email)}&tag=${encodeURIComponent(tagValue)}`;
    console.log("🌐 Final API URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    console.log("📬 Fetch status:", response.status);

    const json = await response.json();
    console.log("📦 JSON Response:", json);

    return {
      firstName: json.firstName || json.first_name,
      lastName: json.lastName || json.last_name,
      email: json.email,
    };
  } catch (error) {
    console.error("❌ Error in fetchUserDetailsByEmail:", error);
    throw error;
  }
}
